<template>
  <div class="mainFooter">
    <div class="mainFooter__header">
        <div class="mainFooter__contacts">
          <div class="mainFooter__contacts__phone">
            <a :href="'tel:' + phone">{{ phone }}</a>
          </div>
          <div class="mainFooter__contacts__email">
            <a :href="'mailto:' + email">{{ email }}</a>
          </div>
        </div>
        <div class="mainFooter__menu">
          <router-link class="mainFooter__menuItem" :to="{name: 'ClubView'}">О КЛУБЕ</router-link>
          <router-link class="mainFooter__menuItem" :to="{name: 'CatalogView'}">МАГАЗИН</router-link>
        </div>
    </div>
    <div class="mainFooter__messengers" id="footer-contacts">
      <div class="mainFooter__messengerItem"><a href="https://t.me/deedcoin_club" target="_blank">Telegram</a></div>
      <div class="mainFooter__messengerItem"><a href="https://max.ru/deedcoin_club" target="_blank">Max</a></div>
      <div class="mainFooter__messengerItem"><a href="https://vk.ru/deedcoin" target="_blank">ВКонтакте</a></div>
      <div class="mainFooter__messengerItem"><a href="https://www.youtube.com/@GhostofKiberDed" target="_blank">YouTube</a></div>
    </div>
    <div class="mainFooter__footer">
      <span class="mainFooter__copyright">© 2026 Все права защищены</span>
      <span class="mainFooter__confidential"><ConsentLink slug="consent-confidential">Политика конфиденциальности</ConsentLink></span>
      <span class="mainFooter__personalData"><ConsentLink slug="consent-personal">Согласие на обработку персональных данных</ConsentLink></span>
    </div>
  </div>
</template>

<script>
import {onMounted, ref} from "vue";
import {useCustomPagesStore} from "@/store/custom-pages";
import ConsentLink from "@/components/ui/ConsentLink.vue";

const DEFAULT_PHONE = '+7-925-862-20-13';
const DEFAULT_EMAIL = 'kiberded.club@yandex.ru';

export default {
  name: "MainFooter",
  components: {ConsentLink},
  setup() {
    const customPagesStore = useCustomPagesStore();
    const phone = ref(DEFAULT_PHONE);
    const email = ref(DEFAULT_EMAIL);

    onMounted(async () => {
      try {
        await customPagesStore.loadCustomPage({page_slug: 'admin-phone'});
        if (customPagesStore.record?.content) {
          phone.value = customPagesStore.record.content;
        }
      } catch (e) { /* keep default */ }

      try {
        await customPagesStore.loadCustomPage({page_slug: 'admin-email'});
        if (customPagesStore.record?.content) {
          email.value = customPagesStore.record.content;
        }
      } catch (e) { /* keep default */ }
    });

    return {phone, email};
  }
}
</script>


<style scoped lang="scss">
.mainFooter {
  margin-top: 64px;

  &__contacts {
    text-align: left;
    font-family: var(--cd-bold-font);
    font-weight: 500;
    font-size: clamp(24px, 4vw, 43px);
    color: var(--cd-highlight-text);
  }

  &__contacts__phone,
  &__contacts__email {
    line-height: 1.2;
  }

  &__menu {
    display: flex;
    flex-direction: column;
    text-align: right;
    font-family: var(--cd-default-font);
    font-weight: 400;
    font-size: 16px;
    gap: 13px;
    padding: 0 24px;

    @include respond-to('sm') { padding: 0; text-align: left; }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: $space-sm;

    @include respond-to('sm') { flex-direction: column; }
  }

  &__messengers {
    margin-top: 64px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;

    @include respond-to('md') { margin-top: 40px; }
  }

  &__messengerItem {
    flex: 1 1 280px;
    max-width: 333px;
    min-height: 140px;
    border-radius: 20px;
    border: 1px solid var(--cd-spoiler-border-color);
    padding: 24px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--cd-bold-font);
    font-weight: 500;
    font-size: clamp(18px, 2.5vw, 28px);

    @include respond-to('sm') {
      flex: 1 1 calc(50% - 5px);
      max-width: none;
    }
    @include respond-to('xs') {
      flex: 1 1 100%;
      max-width: none;
    }
  }

  a {
    color: var(--cd-highlight-text);
    text-decoration: none;

    &:hover { text-decoration: none; }
  }

  &__footer {
    margin-top: 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: $space-sm;
    font-family: var(--cd-default-font);
    font-weight: 400;
    font-size: 14px;
    text-transform: uppercase;

    @include respond-to('sm') { flex-direction: column; gap: $space-xs; }
  }
}
</style>
